import React, { useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import TopBar from "../components/layout/TopBar";
import { useAuth } from "../context/AuthContext";
import { PLANS, TIER_ORDER } from "../lib/plans";

export default function Settings() {
  const { user, setTier } = useAuth();
  const [busy, setBusy] = useState(null);
  const current = user?.tier || "score";

  const choose = async (tier) => {
    if (tier === current) return;
    setBusy(tier);
    try { await setTier(tier); toast.success(`Switched to ${PLANS[tier].name}`); }
    finally { setBusy(null); }
  };

  return (
    <>
      <TopBar title="Settings" subtitle="Plan, account and preferences." />
      <div className="p-6 sm:p-8 max-w-[1200px]">
        <div className="card p-6 mb-8">
          <span className="label-caps">Account</span>
          <div className="grid sm:grid-cols-3 gap-4 mt-3">
            <div><div className="text-xs text-ink-3">Name</div><div className="font-semibold text-ink">{user?.name}</div></div>
            <div><div className="text-xs text-ink-3">Email</div><div className="font-semibold text-ink truncate">{user?.email}</div></div>
            <div><div className="text-xs text-ink-3">Organisation</div><div className="font-semibold text-ink">Gilmours</div></div>
          </div>
        </div>

        <h2 className="text-xl font-bold tracking-tight text-ink mb-1">Your plan</h2>
        <p className="text-sm text-ink-2 mb-5">Switch plans to experience Growth's feature gating. Demo only — no billing.</p>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {TIER_ORDER.map((key) => {
            const plan = PLANS[key];
            const active = current === key;
            return (
              <div key={key} className="card p-6 flex flex-col relative" data-testid={`plan-${key}`}
                style={active ? { borderColor: "#93C020", boxShadow: "0 0 0 1px #93C020" } : {}}>
                {active && <span className="absolute top-5 right-5 text-[10px] font-bold uppercase tracking-wider rounded-full px-2 py-0.5" style={{ background: "rgba(147,192,32,.12)", color: "#678A16" }}>Current</span>}
                <h3 className="font-bold tracking-tight text-ink">{plan.name}</h3>
                <div className="flex items-baseline gap-1 mt-2">
                  <span className="text-4xl font-extrabold tracking-tighter text-ink">£{plan.price}</span>
                  <span className="text-ink-3 text-sm">/month</span>
                </div>
                <p className="text-sm text-ink-2 mt-2 min-h-[40px]">{plan.tagline}</p>
                <ul className="mt-4 space-y-2 flex-1">
                  {plan.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-sm text-ink-2"><Check size={15} strokeWidth={2} className="mt-0.5 shrink-0" color="#678A16" /> {f}</li>
                  ))}
                </ul>
                <button onClick={() => choose(key)} disabled={active || busy} data-testid={`select-plan-${key}`}
                  className={active ? "btn-secondary mt-5 focus-ring" : "btn-primary mt-5 focus-ring"}>
                  {busy === key ? <Loader2 size={16} className="animate-spin" /> : active ? "Current plan" : `Switch to ${plan.name.replace("Growth ", "")}`}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
